<template>
  <SidebarCard productName="Business Studio+" :header="$t('tbs_home_plus__promo')" :logo="BusinessPlusLogo">
    <ul class="tw:list-disc tw:pl-6 tw:text-sm tw:mb-3">
      <li v-for="feature in features" :key="feature">{{ $t(feature) }}</li>
    </ul>

    <BaseLink to="/studio-plus/compare" @click="triggerEvent" class="tw:font-bold tw:text-blue-700">{{
      $t('tbs_mp_learn_more_cta')
    }}</BaseLink>
  </SidebarCard>
</template>
<script setup>
import BaseLink from '@/components/BaseLink.vue'
import SidebarCard from '@/components/homePage/sidebar/SidebarCard.vue'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const BusinessPlusLogo = new URL('/src/assets/img/landing/landing_studio_plus.svg', import.meta.url)

const features = [
  'tbs_home_plus_promo_1',
  'tbs_home_plus_promo_2',
  'tbs_home_plus_promo_3',
  'tbs_home_plus_promo_4',
  'tbs_home_plus_promo_5',
]

const triggerEvent = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_SIDEBAR_PLUS_LEARN_MORE_CLICKED, {
    accommodationId: selectedAccommodationId.value,
  })
}
</script>
